import React from 'react'

import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { TeamsNotificationsForm } from '@/views/Organizations/components/TeamsNotificationsForm'

/**
 * Self-serve Teams setup entry for org admins (edit_users), shown on /users.
 * Opens a modal that connects the org's Teams tenant via Microsoft's
 * admin-consent flow, or shows its status with Reconnect + Disconnect. The
 * Balto-admin multi-provider IntegrationCredentialForm modal is separate and
 * stays Balto-only.
 */
export const ManageTeamsNotificationsButton = ({ organizationId }) => {
  return (
    <ButtonAndFormModal
      buttonLabel="Manage Teams Notifications"
      modalTitle="Manage Teams Notifications"
      modalId="manage-teams-notifications"
      modalProps={{ size: 'small' }}
      buttonProps={{ primary: true }}
      form={<TeamsNotificationsForm organizationId={organizationId} />}
    />
  )
}
